import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-zinc-100 border-y border-zinc-200" data-id="element-21" data-mp="22elmevptxplz">
      <div className="max-w-5xl mx-auto" data-id="element-22" data-mp="1ydi6yabp1vla">
        <div className="text-center mb-16" data-id="element-23" data-mp="1yejh8ckvye1y">
          <p className="text-violet-900 font-display font-extrabold tracking-widest uppercase mb-2" data-id="element-24" data-mp="1ao7ctboumzg4">
            Included today at no additional cost
          </p>
          <h2 className="flex items-center justify-center gap-3 text-4xl md:text-5xl font-black uppercase text-zinc-950" data-id="element-25" data-mp="15r75yyk6dsny">
            <Gift className="text-violet-600 shrink-0 w-9 h-9 md:w-11 md:h-11" aria-hidden="true" data-id="element-26" data-mp="1eq2dqf2vbatd" />
            <span data-id="element-27" data-mp="r0gg3w2593nh">
              5 Professional <span className="text-violet-600" data-id="element-28" data-mp="qzolooka9bys">MMA Coaching</span> Bonus Guides
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-29" data-mp="myd0qwcctewx">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-zinc-200 rounded-2xl p-8 shadow-sm relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-30" data-mp="29rjtincsmb9a" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-violet-900 text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-display font-extrabold text-sm" data-id="element-31" data-mp="1vtd7c4h7hzpg">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-violet-50 border border-violet-200 rounded-full flex items-center justify-center text-violet-600 mb-4" data-id="element-32" data-mp="25r9hasyeqolz">
                <Gift size={24} aria-hidden="true" data-id="element-33" data-mp="3h5n0vlm4ohw7" />
              </div>
              <h3 className="text-xl font-black uppercase mb-2 pr-28 text-zinc-950" data-id="element-34" data-mp="3h7rbemej8f5g">{bonus.title}</h3>
              <p className="text-zinc-950 text-sm font-semibold mb-4 border-l-4 border-violet-600 pl-4" data-id="element-35" data-mp="1h5hzgt81e2jv">
                {bonus.subtitle}
              </p>

              {bonus.bulletsLabel && <p className="text-zinc-700 text-sm mb-3 leading-relaxed" data-id="element-36" data-mp="1q1zcy33vicis">{bonus.bulletsLabel}</p>}
              {bonus.bullets.length > 0 && <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mb-6" data-id="element-37" data-mp="ydyxmppr0ujf">
                  {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-38" data-mp="tfnpcjf3qs3b">
                      <CheckCircle2 size={16} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-39" data-mp="17697u70n900o" />
                      <span className="text-zinc-700 text-sm" data-id="element-40" data-mp="12dpo0sbd58nf">{bullet}</span>
                    </li>)}
                </ul>}

              {bonus.flow && <div className="mb-6" data-id="element-41" data-mp="am9yapeif5sz">
                  {bonus.flowLabel && <p className="text-zinc-700 text-sm mb-3" data-id="element-42" data-mp="j4oy3lv1ajz">{bonus.flowLabel}</p>}
                  <FlowSteps steps={bonus.flow} align="start" data-id="element-43" data-mp="5acyczn6wvx5" />
                </div>}

              {bonus.closing && <p className="text-violet-900 font-semibold text-sm mt-auto pt-4 border-t border-zinc-200" data-id="element-44" data-mp="3msfqk7oj06t6">
                  {bonus.closing}
                </p>}
            </motion.article>)}
        </div>
      </div>
    </section>;
}